import { CheckCircleFilled } from "@ant-design/icons";
import { Tag } from "antd";
import React from "react";
import { $t } from "~/i18n.js";
import { colors } from "~/theme/colors.js";
import { RecencyTable } from "./components/RecencyTable.jsx";
import { RecencyRowTd } from "./components/RecencyRow.jsx";
import {
  mapRecency,
  minRecencyValidThrough,
  setAlertDate,
} from "./components/helpers.js";
import { RecencyValidThrough } from "./components/RecencyValidThrough.jsx";

export const createBISRules = (recency) => {
  return [
    {
      label: $t("BI(s) exam"),
      date: recency.bis_date_exam,
      valid_through: recency.bis_date_exam_valid_to,
      hasDate: !!recency.bis_date_exam_valid_to,
    },
    {
      label: $t("of 20 PIC uren"),
      value: parseInt(recency.bis_uren / 6) / 10,
      min: 20,
      valid_through: recency.bis_uren_valid_to,
      deadline: 120,
    },
    {
      label: $t("of 40 PIC starts"),
      value: recency.bis_starts,
      min: 40,
      valid_through: recency.bis_starts_valid_to,
      deadline: 120,
    },
    {
      label: $t("Ability to Instruct"),
      is_invalid: recency.bis_ati_invalid,
      date: recency.bis_ati,
      valid_through: recency.bis_ati_valid_to,
      deadline: 120,
      hasDate: true,
    },
  ];
};

export const BISRecencyTable = ({ recency, showOnlyInvalid = false }) => {
  if (!recency) return null;

  const items = createBISRules(recency)
    .map(mapRecency)
    .filter((e) => e.isUsed);

  const _items = showOnlyInvalid
    ? items.filter((item) => !item.is_valid || item.alert_date)
    : items;

  const minValidThrough =
    showOnlyInvalid && _items.length === 0
      ? minRecencyValidThrough(items)
      : undefined;

  const limitToOnlyHeader = recency.fis !== "invalid" && _items.length === 0;

  const body = (
    <>
      <tr style={{ width: "100%" }}>
        <td className="col ">
          <span className="bold">{$t("BI(s) recency")}</span>
          {recency.spl === "invalid" && (
            <>
              {" "}
              <br /> <span className="small">{$t("Note: Ongeldig SPL")}</span>
            </>
          )}
        </td>
        <td className="col" />

        <RecencyValidThrough
          is_invalid={recency.bis === "invalid"}
          valid_through={minValidThrough}
          alert_date={setAlertDate(120, minValidThrough)}
        />
      </tr>

      {!limitToOnlyHeader &&
        _items.map((item, index) => (
          <tr key={index}>
            <RecencyRowTd item={item} />
          </tr>
        ))}
    </>
  );
  if (showOnlyInvalid) return body;
  return (
    <RecencyTable title={$t("UK SFCL BI(s) recency, afgelopen 2 jaar")}>
      {body}
    </RecencyTable>
  );
};
